module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-72x72-161195daf4634e831f72ed78dec38c92.png";